import React, { useEffect, useRef } from "react";

import Warning from "assets/images/icons/WarningOrange.svg";

import classes from "./styles.module.scss";
import Button from "components/Button";

const ErrorFallback = ({ fallbackAction = () => {}, error = null }) => {
    const ranForError = useRef(new Set());

    useEffect(() => {
        if (import.meta.env.DEV) return;

        const key = error?.error?.message || "unknown";

        if (ranForError.current.has(key)) return;

        ranForError.current.add(key);

        fallbackAction();
    }, [error, fallbackAction]);

    return (
        <div className={classes.errorFallbackContainer}>
            {/* <div className={classes.errorFallbackContainer}> */}
            {error?.error?.message?.includes("dynamically imported") ||
            error?.error?.message?.includes("Unable to preload CSS") ? (
                <>
                    <h1 style={{ fontSize: "32px", margin: "0 32px", textAlign: "center" }}>
                        A new version of Volta SNAP is available, the page must be reloaded.
                    </h1>
                    <h2>Your progress has been saved.</h2>
                    <Button onClick={() => window.location.reload(true)}>Reload Page</Button>
                </>
            ) : (
                <>
                    <h1 style={{ fontSize: "32px" }}>Something went wrong.</h1>
                    <h2>Your progress has been saved.</h2>
                    <img src={Warning} style={{ height: "100px" }} alt="error image" />{" "}
                </>
            )}
            {/* </div> */}
        </div>
    );
};

export default ErrorFallback;
